var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 141.569,
    height: 134.195,
    viewBox: "0 0 141.569 134.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83dc0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12a319"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4418",
    "data-name": "Group 4418",
    transform: "translate(-285 -2572.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M393.712,86.72a6.316,6.316,0,0,0-6.543,6.044v74.19c.33,8.021,12.783,7.992,13.111,0V92.764A6.329,6.329,0,0,0,393.712,86.72Z",
    transform: "translate(4.884 2509.995)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M238.815,86.72a6.329,6.329,0,0,0-6.568,6.044v74.19c.331,8.009,12.808,8,13.136,0V92.764a6.33,6.33,0,0,0-6.568-6.044",
    transform: "translate(116.97 2509.995)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M316.3,173.44A6.557,6.557,0,0,0,309.754,180v32.541c.33,8.7,12.782,8.671,13.11,0V180a6.57,6.57,0,0,0-6.568-6.558",
    transform: "translate(60.894 2443.588)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M471.128,216.8a6.558,6.558,0,0,0-6.543,6.558v8.562c.331,8.7,12.783,8.671,13.111,0v-8.562a6.57,6.57,0,0,0-6.568-6.558",
    transform: "translate(-51.126 2412.216)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M6.568,216.8A6.57,6.57,0,0,0,0,223.358v8.562c.331,8.677,12.783,8.7,13.11,0v-8.562A6.557,6.557,0,0,0,6.568,216.8Z",
    transform: "translate(285 2412.216)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M83.983,130.08a6.57,6.57,0,0,0-6.568,6.558v56.518c.331,8.678,12.784,8.7,13.111,0V136.638a6.558,6.558,0,0,0-6.543-6.558",
    transform: "translate(228.99 2474.959)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M161.4,0a6.407,6.407,0,0,0-6.568,6.218v121.8c.331,8.228,12.783,8.245,13.11,0V6.218A6.394,6.394,0,0,0,161.4,0",
    transform: "translate(172.979 2572.737)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.85e5a4d5f99f1f7a1268237a2947c4f6.svg";
export { ForwardRef as ReactComponent };